/**
 * Created by Fatih on 1.07.2016.
 */
import $ from 'jquery';
import { replace, basePathname } from './store/history.js';

const $responsibleGamingPage = $('.responsible-menu');

function setResponsibleGamingPageActive(bool) {
	if (bool) {
		$responsibleGamingPage.addClass('menu--is-open');
		setTimeout(function () {
			$responsibleGamingPage.css('transform', 'initial');
			//this part is for smooth scrolling in iOS
			$('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				$('.pusher').children().each(function () {
					$(this).addClass('u-dn');
				});
			}
		}, 500);
	} else {
		$responsibleGamingPage.removeClass('menu--is-open');
		$responsibleGamingPage.removeAttr('style');
		//this part is for smooth scrolling in iOS
		$('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			$('.pusher').children().each(function () {
				$(this).removeClass('u-dn');
			});
		}
	}
}

$responsibleGamingPage.find('.icon-close').click(() => {
	//var router = require('./router');
	replace(basePathname());
});

export default {
	setResponsibleGamingPageActive
};



// WEBPACK FOOTER //
// ./mobile-core/src/responsible-gaming.js